import { getStateColors } from './icon_helpers';

/**
 * Creates a documentation training - induction icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createInductionIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - induction icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="12" cy="6" r="3" /><path fill="${colors.iconColor}" d="M11 10l-2 3 2 1v4h2v-4l2-1-2-3z" /><path fill="${colors.iconColor}" d="M7 20h10v2H7z" /><path fill="${colors.iconColor}" d="M12 2l5 3-5 3-5-3z" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - job safety analysis icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createJobSafetyAnalysisIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - job safety analysis icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="4" y="2" width="12" height="18" rx="1" /><path fill="${colors.iconColor}" d="M7 6l1.5 1.5L11 5" /><path fill="${colors.iconColor}" d="M7 10l1.5 1.5L11 9" /><path fill="${colors.iconColor}" d="M7 14l1.5 1.5L11 13" /><circle fill="${colors.iconColor}" cx="19" cy="12" r="4" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="2" cx="19" cy="12" r="2.5" /><path fill="${colors.iconColor}" d="M21 14l2 2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - job specific training icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createJobSpecificTrainingIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - job specific training icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<circle fill="${colors.iconColor}" cx="8" cy="6" r="2.5" /><path fill="${colors.iconColor}" d="M7 9l-1 3 1.5 1v4h2v-4l1.5-1L10 9z" /><rect fill="${colors.iconColor}" x="13" y="4" width="8" height="3" /><rect fill="${colors.iconColor}" x="15" y="7" width="4" height="7" /><rect fill="${colors.iconColor}" x="13" y="14" width="8" height="3" /><circle fill="${colors.iconColor}" cx="17" cy="10" r="1.5" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - lock out tag out icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createLockOutTagOutIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - lock out tag out icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="7" y="11" width="10" height="10" rx="1" /><path fill="${colors.iconColor}" d="M9 11V7c0-1.7 1.3-3 3-3s3 1.3 3 3v4" /><circle fill="${colors.iconColor}" cx="12" cy="16" r="1.8" /><rect fill="${colors.iconColor}" x="14" y="2" width="7" height="6" rx="0.5" /><rect fill="${colors.iconColor}" x="15.5" y="3.5" width="4" height="1" /><rect fill="${colors.iconColor}" x="15.5" y="5" width="3" height="1" /><path fill="${colors.iconColor}" d="M18 8l-2 3" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - permit to work icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createPermitToWorkIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - permit to work icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="5" y="2" width="14" height="18" rx="1" /><rect fill="${colors.iconColor}" x="7" y="5" width="10" height="1.5" /><rect fill="${colors.iconColor}" x="7" y="8" width="10" height="1.5" /><rect fill="${colors.iconColor}" x="7" y="11" width="10" height="1.5" /><circle fill="${colors.iconColor}" cx="15" cy="16" r="3.5" /><path fill="none" stroke="${colors.iconColor}" stroke-width="2" d="M13.5 16l1 1 2-2" /><rect fill="${colors.iconColor}" x="11" y="20" width="2" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - policy icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createPolicyIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - policy icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<rect fill="${colors.iconColor}" x="6" y="2" width="12" height="18" rx="1" /><path fill="${colors.iconColor}" d="M12 6l-3 2v4c0 2 1.3 3 3 3s3-1 3-3V8z" /><rect fill="${colors.iconColor}" x="8" y="16" width="8" height="1" /><rect fill="${colors.iconColor}" x="8" y="18" width="6" height="1" /><rect fill="${colors.iconColor}" x="11" y="20" width="2" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - procedure icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createProcedureIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - procedure icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M5 3h14v18H5z" /><circle fill="none" stroke="${colors.iconColor}" stroke-width="2.5" cx="9" cy="8" r="1.8" /><text fill="${colors.iconColor}" x="9" y="10" font-size="3" font-weight="bold" text-anchor="middle">1</text><circle fill="none" stroke="${colors.iconColor}" stroke-width="2.5" cx="9" cy="14" r="1.8" /><text fill="${colors.iconColor}" x="9" y="16" font-size="3" font-weight="bold" text-anchor="middle">2</text><circle fill="none" stroke="${colors.iconColor}" stroke-width="2.5" cx="9" cy="20" r="1.8" /><text fill="${colors.iconColor}" x="9" y="22" font-size="3" font-weight="bold" text-anchor="middle">3</text><rect fill="${colors.iconColor}" x="12" y="7" width="5" height="2" /><rect fill="${colors.iconColor}" x="12" y="13" width="5" height="2" /><rect fill="${colors.iconColor}" x="12" y="19" width="5" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - risk assessment icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createRiskAssessmentIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - risk assessment icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M5 2h14v20H5z" /><path fill="${colors.iconColor}" d="M12 5l-5 4 5 4 5-4z" /><rect fill="${colors.iconColor}" x="7" y="15" width="3" height="5" /><rect fill="${colors.iconColor}" x="10.5" y="13" width="3" height="7" /><rect fill="${colors.iconColor}" x="14" y="11" width="3" height="9" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - safe operating procedures icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createSafeOperatingProceduresIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - safe operating procedures icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M5 3h10v18H5z" /><circle fill="${colors.iconColor}" cx="10" cy="9" r="3.5" /><path fill="none" stroke="${colors.iconColor}" stroke-width="2" d="M8 9l1.5 1.5L12 8" /><rect fill="${colors.iconColor}" x="6" y="14" width="8" height="1" /><rect fill="${colors.iconColor}" x="6" y="16" width="6" height="1" /><rect fill="${colors.iconColor}" x="15" y="6" width="4" height="2" /><path fill="${colors.iconColor}" d="M17 9l-2 2 2 2 2-2z" /><rect fill="${colors.iconColor}" x="15" y="14" width="4" height="2" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

/**
 * Creates a documentation training - safety data sheet sds location icon
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {string} Data URL containing SVG icon
 */
export const createSafetyDataSheetSdsLocationIcon = (state = null) => {
  const colors = getStateColors(state);

  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="${colors.pinColor}"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="${colors.ringColor}" stroke="${colors.ringColor}" stroke-width="12.6"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- documentation training - safety data sheet sds location icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(3.2) translate(-21, -21)">
        <g  transform="translate(9 9)">
<path fill="${colors.iconColor}" d="M6 2h12l4 4v14c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h2z" /><path fill="${colors.iconColor}" d="M18 2v4h4" /><path fill="${colors.iconColor}" d="M12 9l-3 3 3 3 3-3z" /><rect fill="${colors.iconColor}" x="6" y="17" width="12" height="1.5" /><rect fill="${colors.iconColor}" x="6" y="19" width="8" height="1" />
    </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const documentationtrainingIcons = {
  induction: createInductionIcon,
  job_safety_analysis: createJobSafetyAnalysisIcon,
  job_specific_training: createJobSpecificTrainingIcon,
  lock_out_tag_out: createLockOutTagOutIcon,
  permit_to_work: createPermitToWorkIcon,
  policy: createPolicyIcon,
  procedure: createProcedureIcon,
  risk_assessment: createRiskAssessmentIcon,
  safe_operating_procedures: createSafeOperatingProceduresIcon,
  safety_data_sheet_sds_location: createSafetyDataSheetSdsLocationIcon
};
